import styled, { css } from 'styled-components';

export const ItemCountStyled = styled.div`
  ${({ theme }) => css`
    padding-left: ${theme.spacings[600]};
    padding-top: ${theme.spacings[300]};
    padding-right: ${theme.spacings[600]};
    padding-bottom: ${theme.spacings[300]};
    border-radius: ${theme.radii[700]};
    border: 1px solid ${theme.colors.blue[800]};
  `}
`;
